<template>
  <!-- Media Section -->
  <section class="py-16 bg-white">
    <div class="container mx-auto px-4">
      <!-- Header Section -->
      <div class="mb-10">
        <h2 class="text-3xl font-bold mb-2 text-[#B89666] text-center">Glas stroke</h2>
        <h3 class="text-3xl font-semibold mb-1 text-center">Preberi, kaj o aktualnih pravnih in upravnih temah pravijo strokovnjaki.</h3>
        <p class="text-gray-600 mt-8 text-center">
          V rubriki Glas stroke odpiramo prostor strokovnjakom in njihovim razmišljanjem, izkušnjam in pogledom na pravo ter upravo v praksi.<br><br>

          Spoznaj njihove poglede, izkušnje in nasvete – jasno, razumljivo in brez zapletov.<br><br>
        </p>
      </div>
      <!-- Media Grid -->
      <div class="flex flex-wrap gap-4 justify-center">
        <MediaCard 
          title="Žan Borštnar OP-B"
          slug="zan-borstnar-op-b"
          excerpt="Pogovor z Žanom Borštnarjem, OP-B, o najnovejših trendih v pravu in upravnih procesih. Strokovnjak deli svoje izkušnje in nasvete za uspešno reševanje pravnih izzivov."
          featured_image="media/zan-borstnar-op-b/625x480.png"
          author="Lexo"
          published_at="01.09.2025"
          :tags="['Strokovno', 'Izkušnje', 'Pogovor']"
          read_time="8 min"
          :isTrending="true"
        />
      </div>
      <!-- Call to Action -->
      <div class="text-center mt-10">
        <a 
          :href="route('web.media.list')" 
          class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition-colors duration-200"
        >
          <i class="ti ti-eye mr-2"></i>Poglej vse
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
import MediaCard from '@/Pages/Web/Media/MediaCard.vue';
</script> 